import { Box } from "@mui/material";
import { useTheme } from "@mui/material";

import * as Typography from "@/Components/Typography/Typography";
import { Card } from "@/Components/v2/atoms/Card/Card";
import { colors } from "@/Utils";

const CatchErrorCard = (props: any) => {
  const { title, message, height } = props;
  const theme = useTheme();

  return (
    <Card>
      <Typography.H3 margin={10} mrleft={10} fSize={13} fweight={500}>
        {title}
      </Typography.H3>
      <Box
        sx={{
          width: "calc(100% - 16px)",
          height: `${height || 365}px`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: theme.palette.mode === "dark" ? colors.cardBg : colors.secondaryColor,
          marginTop: 0,
        }}
      >
        <Box
          sx={{
            fontSize: "12px",
            color: theme.palette.mode === "dark" ? colors.white : colors.black,
            opacity: 0.4,
            padding: "0 15px",
            textAlign: "center",
          }}
        >
          {message ?? `Something went wrong! Please refresh the page and try again.`}
        </Box>
      </Box>
    </Card>
  );
};
export default CatchErrorCard;
